module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tjhzs_mask",
    style: (_vm.auto ? _vm.auto_style : _vm.mask_style),
    on: {
      "click": _vm.triggerEvent
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-175e00a6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mask/Maskdiv.vue
// module id = 166
// module chunks = 1